import React, { createContext, useContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

const CommonContext = createContext(undefined);

export const CommonProvider = ({ children }) => {
    const [clientId, setClientId] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('en')
    const token = JSON.parse(localStorage.getItem("authToken"));

    // Optimized: Only check token on initial load and when it changes
    useEffect(() => {
        if (token) {
            const decodedToken = jwtDecode(token);
            setIsAdmin(decodedToken.isAdmin);
        }
    }, [token]);

    const value = {
        clientId,
        setClientId,
        isAdmin,
        setSelectedLanguage,
        selectedLanguage,
        setIsAdmin
    };

    return <CommonContext.Provider value={value}>{children}</CommonContext.Provider>;
};

export const useCommonContext = () => {
    const context = useContext(CommonContext);
    if (!context) {
        throw new Error('useCommentContext must be used within a CommentProvider');
    }
    return context;
};